import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// let baseURL = ''
// if (process.NODE_ENV === 'development') {
//   baseURL = '/api'
// } else {
//   baseURL = process.env.VUE_APP_API_BASE_URL
// }
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  headers: {
    'Content-Type': 'application/json;'
    // 'requestId': ''
},
  // baseURL: baseURL,
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: '/api',
  // baseURL: 'https://openapi.cens.cn',
  timeout: 10000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  Vue.prototype.$loading.hide()
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  if (config.requestBase === 'VUE_APP_API_BASE_URL_OSS') {
    config.baseURL = process.env.VUE_APP_API_BASE_URL_OSS
  } else if (config.requestBase === 'VUE_APP_API_BASE_URL_OSS_T') {
    config.baseURL = process.env.VUE_APP_API_BASE_URL_OSS_T
  }
  if (config.contentType) {
    config.headers['Content-Type'] = config.contentType
  }
  Vue.prototype.$loading.show()
  // const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  // if (token) {
  //   config.headers[ACCESS_TOKEN] = token
  // }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  Vue.prototype.$loading.hide()
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
